module.exports = __webpack_public_path__ + "static/media/poziome3.db41ba28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/szatnia/poziome3.jpg
// module id = 301
// module chunks = 0